import React from 'react';
import ReactDOM from 'react-dom';

import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Jumbotron from 'react-bootstrap/Jumbotron';


import ModalHeader from 'react-bootstrap/ModalHeader';
import ModalFooter from 'react-bootstrap/ModalFooter';
import ModalBody from 'react-bootstrap/ModalBody';
import ModalDialog from 'react-bootstrap/ModalDialog';
import ModalTitle from 'react-bootstrap/ModalTitle';




export default class GameOver extends React.Component {
    render() {

        let question_plural = "questions";

        if(this.props.dodged == 1)
        {
            question_plural = "question";
        }


        if (!this.props.show) return null;

        return (
                
                <ModalDialog size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <ModalHeader closeButton>
                    <ModalTitle>GAME OVER</ModalTitle>
                </ModalHeader>

                <ModalBody>
                    <p>You dodged {this.props.dodged} devious {question_plural}</p>
                </ModalBody>

                <ModalFooter>
                    <Button variant="secondary">Try Again</Button>
                    <Button variant="primary">Share</Button>
                </ModalFooter>
                </ModalDialog>


      
        )
    }
  }
  
